import apiService from "@/lib/api";

const DASHBOARD_BASE = "/api/v2/dashboard";
const CANDIDATE_BASE = "/api/v2/candidate";
const SUPER_ADMIN_DASHBOARD_BASE = "/api/v2/admin";

export const DashboardService = {
  // `flowId` is ignored server-side whenever `jobId` is also given — a
  // specific job's own flow always wins.
  fetDashboardStats: async (jobId = "", flowId = "") => {
    try {
      const params = {
        ...(jobId ? { job_id: jobId } : {}),
        ...(flowId ? { flow_id: flowId } : {}),
      };
      const response = await apiService.getSecure(`${DASHBOARD_BASE}/admin-dashboard-stats`, { params });
      return response.data;
    } catch (error) {
      console.error("Error while fetching dashboard stats:", error);
      throw error;
    }
  },

  fetCandidateList: async ({ params }) => {
    try {
      const response = await apiService.getSecure(`${CANDIDATE_BASE}/list`, { params });
      return response.data;
    } catch (error) {
      console.error("Error while fetching candidate list:", error);
      throw error;
    }
  },

  fetchSuperAdminDashboard: async () => {
    try {
      const response = await apiService.getSecure(`${SUPER_ADMIN_DASHBOARD_BASE}/stats`,);
      return response.data;
    } catch (error) {
      console.error('Error while fetching candidate list:', error);
      throw error;
    }
  }
};
